<template>
  <div>
    <Filters
      :filters="familyTypesFilters"
      filter-key="familyTypes"
      :initial-data="filtersStatus.familyTypesFilters"
      :loading="filtersLoading"
    />

    <ViewActionButtons :buttons="actionButtons" />

    <TableWrapper
      :table-columns="familyTypesColumns"
      table-key="familyTypes"
      row-key="tableId"
      @editFamilyType="openEditModal"
    />

    <CreateEditFamilyType
      v-if="openCreateEditFamilyType"
      :is-modal-edit="isModalEdit"
      :initial-data="initialFamilyTypeData"
      @dialogClose="handleDialogClose"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { analysesApi } from '@/api';
  import { familyTypesColumns, familyTypesFilters } from '@/config';
  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import ViewActionButtons from '@/components/ViewActionButtons.vue';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';
  import CreateEditFamilyType from './CreateEditFamilyType.vue';

  export default {
    name: 'FamilyTypesIndex',
    components: {
      Filters,
      TableWrapper,
      ViewActionButtons,
      CreateEditFamilyType,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        familyTypesColumns,
        familyTypesFilters,
        actionButtons: [
          {
            text: this.$t('familyTypes.addFamilyType'),
            type: 'primary',
            permissions: ['familyTypeManage'],
            action: () => {
              this.openCreateEditFamilyType = true;
            },
          },
        ],
        openCreateEditFamilyType: false,
        isModalEdit: false,
        initialFamilyTypeData: {},
      };
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const familyTypesIndex = await analysesApi.familyTypesIndex(
            this.tableFilters('familyTypes'),
            this.filtersStatus.familyTypes,
            { signal }
          );
          const familyTypesCount = await analysesApi.familyTypesCount(
            this.filtersStatus.familyTypes,
            { signal }
          );
          this.updateTableRows({
            tableKey: 'familyTypes',
            rows: familyTypesIndex.data,
          });
          this.updateTableCount({
            tableKey: 'familyTypes',
            count: familyTypesCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
      openEditModal(row) {
        this.initialFamilyTypeData = row;
        this.isModalEdit = true;
        this.openCreateEditFamilyType = true;
      },
      handleDialogClose(status) {
        this.openCreateEditFamilyType = false;
        if (this.isModalEdit) this.isModalEdit = false;
        if (status.success) this.tableRows();
      },
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
  };
</script>
